export function onSendResultNotify(callback){
    window._xdf_tpa_app_function_register_map.sendResultNotify = callback;
}